var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var LocationPathHelper = /** @class */ (function () {
    function LocationPathHelper() {
    }
    LocationPathHelper.stringifyParams = function (params) {
        return Object.keys(params)
            .map(function (key) {
            var e_1, _a;
            var value = params[key];
            if (Array.isArray(value)) {
                var result = [];
                try {
                    for (var value_1 = __values(value), value_1_1 = value_1.next(); !value_1_1.done; value_1_1 = value_1.next()) {
                        var arrayValue = value_1_1.value;
                        result.push(encodeURIComponent(key + "[]") + "=" + encodeURIComponent(arrayValue));
                    }
                }
                catch (e_1_1) { e_1 = { error: e_1_1 }; }
                finally {
                    try {
                        if (value_1_1 && !value_1_1.done && (_a = value_1.return)) _a.call(value_1);
                    }
                    finally { if (e_1) throw e_1.error; }
                }
                return result.join('&');
            }
            return encodeURIComponent(key) + "=" + encodeURIComponent(value);
        })
            .join('&');
    };
    LocationPathHelper.getPathName = function () {
        if (!window) {
            return false;
        }
        return window.location.pathname;
    };
    LocationPathHelper.getPathNameAsArray = function () {
        var pathName = LocationPathHelper.getPathName();
        return pathName ? pathName.slice(1).split('/') : [];
    };
    LocationPathHelper.getWindowLocationSearch = function () {
        var _a;
        return ((_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.search) || '';
    };
    LocationPathHelper.get = function (name) {
        // Grabs location.search and executes the regex expression
        // which grabs the URL parameter value of `name`.
        return (decodeURIComponent((new RegExp("[?|&]" + name + "=([^&;]+?)(&|#|;|$)").exec(this.getWindowLocationSearch()) || [null, ''])[1].replace(/\+/g, '%20')) || null);
    };
    LocationPathHelper.removeQueryParams = function () {
        window.history.replaceState(null, null, window.location.href.split('?')[0]);
    };
    return LocationPathHelper;
}());
export default LocationPathHelper;
